import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AlphabeticalSelectionListComponent } from "@onsip/web/features/shared/components/alphabeticalSelectionList/alphabetical-selection-list.component";
import { MatDividerModule } from "@angular/material/divider";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { PipesModule } from "@onsip/web/features/shared/pipes/pipes.module";
import { MatSelectModule } from "@angular/material/select";

@NgModule({
  declarations: [AlphabeticalSelectionListComponent],
  exports: [AlphabeticalSelectionListComponent],
  imports: [CommonModule, MatDividerModule, MatCheckboxModule, PipesModule, MatSelectModule]
})
export class AlphabeticalSelectionListModule {}
